import { render, staticRenderFns } from "./Step3-Summary.vue?vue&type=template&id=3a0ed80e&scoped=true&"
import script from "./Step3-Summary.vue?vue&type=script&lang=js&"
export * from "./Step3-Summary.vue?vue&type=script&lang=js&"
import style0 from "./Step3-Summary.vue?vue&type=style&index=0&id=3a0ed80e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ed80e",
  null
  
)

export default component.exports